

function classes(options) {
    var cls = [];
    for(var p in options) {
        if(options[p])
            cls.push(p);
    }
    return cls;
}

module.exports = {
    classes: classes
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui-vue/Util.js
 ** module id = 49
 ** module chunks = 0
 **/